export default {
    searchList: {
        searchTxt: [
            {
                name: '业务单号',
                value: 'taskNos',
                type: 'input',
                unfold: true,
                batch: true,
                span: 3
            },
            {
                name: '客户订单号',
                value: 'customerOrderNos',
                type: 'input',
                unfold: true,
                batch: true,
                span: 3
            },
            {
                name: '业务类型',
                value: 'businessType',
                type: 'select',
                optionNum: 'BUSINESS_TYPE',
                options: [],
                unfold: true,
                span: 3
            },
            {
                name: '计费异常操作类型',
                value: 'exceptionOperationTypes',
                type: 'select',
                optionNum: 'EXCEPTION_OPERATION_TYPE',
                options: [],
                unfold: true,
                span: 3
            },
            {
                name: '交易规则',
                value: 'rateCode',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '处理标识状态',
                value: 'handldFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: true, label: '已处理' },
                    { value: false, label: '未处理' }
                ],
                unfold: true,
                span: 3
            },
            {
                name: '创建时间',
                value: 'createTime',
                startTime: 'createTimeStart',
                endTime: 'createTimeEnd',
                startPlaceholder: '创建开始日期',
                endPlaceholder: '创建结束日期',
                type: 'time',
                timeNum: 7,
                unfold: true,
                span: 5
            },
            {
                name: '承运商',
                value: 'carrierName',
                type: 'advance',
                unfold: true,
                span: 4,
                advanceConfig: [
                    { prop: 'suppliersNameCn', value: '承运商名称' },
                    { prop: 'suppliersCode', value: '承运商编码' }
                ],
                tableConfig: [
                    { prop: 'suppliersNameCn', value: '承运商名称' },
                    { prop: 'suppliersCode', value: '承运商编码' }
                ],
                advanceUrl: 'ebSupplier/searchBySupplier',
                cbParams: ['suppliersNameCn#carrierName', 'suppliersCode#carrierCode']
            },
            {
                name: '客户',
                value: 'customerName',
                type: 'advance',
                unfold: true,
                advanceConfig: [
                    { prop: 'ebcuNameCn', value: '客户名称' },
                    { prop: 'pmCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'pmCode', value: '客户编码' },
                    { prop: 'ebcuNameCn', value: '客户名称' }
                ],
                advanceUrl: '/ebCustomer/searchByEbCustomer',
                cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName'],
                span: 4
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        hasMaxBtnNum: true,
        maxBtnNum: 3,
        clickState: false,
        selectBtn: true,
        height: 400,
        columns: [
            {
                label: '创建用户',
                prop: 'createUserName',
                sort: true,
                width: 150
            },
            {
                label: '创建时间',
                prop: 'createTime',
                sort: true,
                width: 150
            },
            {
                label: '修改用户',
                prop: 'updateUserName',
                sort: true,
                width: 150
            },
            {
                label: '修改时间',
                prop: 'updateTime',
                sort: true,
                width: 182
            },
            {
                label: '业务单号',
                sort: true,
                prop: 'taskNo',
                type: 'clickable',
                width: 180
            },
            {
                label: '客户单号',
                sort: true,
                prop: 'customerOrderNo',
                width: 180
            },
            {
                label: '计费异常日志',
                sort: true,
                prop: 'exceptionLog',
                width: 180
            },
            {
                label: '计费异常类型',
                prop: 'exceptionType',
                type: 'select',
                optionNum: 'OTP_EXCEPTION_TYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '变量分类名称',
                prop: 'exceptionName',
                sort: true,
                width: 160
            },
            {
                label: '分公司编码',
                prop: 'companyCode',
                sort: true,
                width: 160
            },
            {
                label: '分公司名称',
                prop: 'companyName',
                sort: true,
                width: 160
            },
            {
                label: '服务平台编码',
                prop: 'siteCode',
                sort: true,
                width: 160
            },
            {
                label: '服务平台名称',
                prop: 'siteName',
                sort: true,
                width: 160
            },
            {
                label: '业务类型名称',
                prop: 'businessTypeName',
                sort: true,
                width: 160
            },
            {
                label: '交易规则',
                prop: 'rateCode',
                type: 'clickable',
                sort: true,
                width: 160
            },
            {
                label: '费用编码',
                prop: 'feeCode',
                sort: true,
                width: 160
            },
            {
                label: '费用名称',
                prop: 'feeName',
                sort: true,
                width: 160
            },
            {
                label: '收付标识',
                prop: 'rpFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: 'R', label: '应收' },
                    { value: 'P', label: '应付' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '商品编码',
                prop: 'itemCode',
                sort: true,
                width: 160
            },
            {
                label: '商品名称',
                prop: 'itemName',
                sort: true,
                width: 160
            },
            {
                label: '计费组',
                prop: 'materialGroup',
                sort: true,
                width: 160
            },
            {
                label: '商品分类',
                prop: 'itemClassName',
                sort: true,
                width: 160
            },
            {
                label: '商品行号',
                prop: 'itemLineNo',
                sort: true,
                width: 160
            },
            {
                label: '发车时间',
                prop: 'feeDate',
                sort: true,
                width: 160
            },
            {
                label: '异常处理标识状态',
                prop: 'handldFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: '1', label: '已处理' },
                    { value: '0', label: '未处理' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '变量分类责任人',
                prop: 'responsibleCode',
                sort: true,
                width: 160
            },
            {
                label: '订单类型',
                prop: 'orderType',
                type: 'select',
                optionNum: 'ORDER_TYPE',
                options: [],
                sort: true,
                width: 130
            },
            {
                label: '客户合同号',
                prop: 'customerContractNo',
                sort: true,
                width: 160
            },
            {
                label: '供应商合同号',
                prop: 'carrierContractNo',
                sort: true,
                width: 160
            },
            {
                label: '客户名称',
                prop: 'customerName',
                sort: true,
                width: 160
            },
            {
                label: '客户编码',
                prop: 'customerCode',
                sort: true,
                width: 160
            },
            {
                label: '供应商编码',
                prop: 'carrierCode',
                sort: true,
                width: 130
            },
            {
                label: '供应商名称',
                prop: 'carrierName',
                sort: true,
                width: 160
            },
            {
                label: '计费模板名称',
                prop: 'templateName',
                sort: true,
                width: 180
            },
            {
                label: '计费模板编码',
                prop: 'templateCode',
                sort: true,
                width: 180
            },
            {
                label: '交易代码',
                prop: 'discountRate',
                sort: true,
                width: 160
            },
            {
                label: '计费异常操作类型',
                prop: 'exceptionOperationType',
                type: 'select',
                optionNum: 'EXCEPTION_OPERATION_TYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '计费状态',
                prop: 'exceptionStatus',
                type: 'select',
                optionNum: '',
                options: [
                    { value: 0, label: '计费失败' },
                    { value: 1, label: '计费成功' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '出入库类型',
                prop: 'inOutType',
                type: 'select',
                optionNum: 'OTP_IN_OUT_TYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '计费方式',
                prop: 'calculateType',
                type: 'select',
                optionNum: 'BMS_CALCULATE_TYPE_2',
                options: [],
                sort: true,
                width: 160
            }
        ],
        action: [],
        leftOperation: false,
        leftWidth: 240
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50, 200]
    },
    searchTotalTitle: [
        {
            name: '客户主合同号',
            value: 'customerContractNo',
            type: 'input',
            unfold: true,
            span: 3
        },
        {
            name: '承运商主合同号',
            value: 'carrierContractNo',
            type: 'input',
            unfold: true,
            span: 3
        },
        {
            name: '分公司',
            value: 'companyName',
            unfold: true,
            multiple: true,
            span: 4,
            type: 'advance',
            multipleTableColumn: {
                prop: 'escoCompanyNameCn', 'value': '分公司名称'
            },
            advanceConfig: [
                { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
                { prop: 'escoCompanyNo', 'value': '分公司编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
                { prop: 'escoCompanyNo', 'value': '分公司编码' }
            ],
            advanceUrl: '/searchBrand',
            cbParams: ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode']
        },
        {
            name: '服务平台',
            advanceLabel: '服务平台',
            value: 'siteName',
            multiple: true,
            border: true,
            dialogWidth: '800px',
            multipleTableColumn: {
                prop: 'escoCompanyNameCn', 'value': '服务平台名称'
            },
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            advanceUrl: '/searchPlatform',
            type: 'advance',
            cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
        },
        {
            name: '费用名称',
            value: 'feeCodes',
            type: 'select',
            optionNum: 'OTP_FEE_NAME',
            options: [],
            multiple: true
        },
        {
            name: '计费模板编码',
            value: 'templateCode',
            type: 'input'
        },
        {
            name: '收付标识',
            value: 'rpFlag',
            type: 'select',
            optionNum: '',
            options: [
                { value: 'R', label: '应收' },
                { value: 'P', label: '应付' }
            ],
            unfold: true,
            span: 3
        },
        {
            name: '变量分类名称',
            value: 'exceptionCodes',
            type: 'select',
            optionNum: 'OTP_EXCEPTION_NAME',
            options: [],
            unfold: true,
            multiple: true,
            span: 3
        },
        {
            name: '变量分类责任人',
            value: 'responsibleCode',
            type: 'input',
            unfold: true,
            span: 3
        },
        {
            name: '计费方式',
            value: 'calculateType',
            type: 'select',
            optionNum: 'BMS_CALCULATE_TYPE_2',
            options: []
        }
    ],
    pickerConfig: {
        shortcuts: [
            { type: 'd', num: 6, text: '最近一周' },
            { type: 'M', num: 1, text: '最近一个月' },
            { type: 'M', num: 3, text: '最近三个月' }
        ]
    }
};
